import Vue from 'vue'
import template from './index.pug'

// @vue/component
export default Vue.extend({
  template: template(),
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
